import React from 'react';
import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';

import { IMatrixScopePanelProps } from './PlanningControlCenter.types';

export default class PlanningMatrixScopePanel extends React.PureComponent<
  IMatrixScopePanelProps
> {
  render(): React.ReactNode {
    const { scope, busy, onConfirmAll } = this.props;

    return (
      <Stack spacing={2}>
        <Box>
          <Button
            variant="contained"
            startIcon={<TaskAltOutlinedIcon />}
            disabled={busy || scope.length === 0}
            onClick={onConfirmAll}
          >
            Confirm All Scope
          </Button>
        </Box>

        {scope.length === 0 ? (
          <Alert severity="info">
            Generate recommendations to populate the Historical Variable scope.
          </Alert>
        ) : (
          scope.map((item) => (
            <Paper key={Number(item.rid)} variant="outlined" sx={{ p: 2 }}>
              <Typography fontWeight={700}>
                {String(
                  item.nam ??
                  item.mtn ??
                  item.mtc ??
                  `Scope ${item.rid}`,
                )}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Products: {String(item.prc ?? item.productcount ?? 0)} ·
                Locations: {String(item.lcc ?? item.locationcount ?? 0)} ·
                Accounts: {String(item.acc ?? item.accountcount ?? 0)}
              </Typography>
            </Paper>
          ))
        )}
      </Stack>
    );
  }
}
